import store from '@Store';
import { generatePath } from 'react-router';
import history from '@AppRoutes/history';
import { paths } from '@AppRoutes/constants';
import Auth from '@Services/Auth';
import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import { withGlobalSpinnerActionEnhancer } from '@Utils/Redux/withGlobalSpinnerActionEnhancer';
import {
  STEPS,
  typeOfRemoteAccessDialog,
  remoteAccessDialogSetStepReducerType,
  remoteAccessDialogSetDepartmentsReducerType,
  remoteAccessDialogSetIsLoadingReducerType,
  typeOfRemoteAccessLoginPromptDialog,
} from './RemoteAccessDialogConstants';
import { sendEmailForEligibility, activateEmailForDepartmentId } from './RemoteAccessService';

export function setStep(step) {
  return {
    type: remoteAccessDialogSetStepReducerType,
    payload: { step },
  };
}

export function setDepartments(departments) {
  return {
    type: remoteAccessDialogSetDepartmentsReducerType,
    payload: { departments },
  };
}

export function setIsLoading(isLoading) {
  return {
    type: remoteAccessDialogSetIsLoadingReducerType,
    payload: { isLoading },
  };
}

export function openRemoteAccessDialog() {
  return (dispatch) => {
    // For anonymous - open login prompt dialog
    if (!Auth.isLoggedIn() || Auth.isAnonymousUser()) {
      dispatch(
        updateDialog({
          id: typeOfRemoteAccessLoginPromptDialog,
          dialogType: typeOfRemoteAccessLoginPromptDialog,
          onSignInClick: () => {
            history.push({
              pathname: generatePath(paths.LOGIN),
            });
          },
        })
      );
      return;
    }

    dispatch(
      updateDialog({
        id: typeOfRemoteAccessDialog,
        dialogType: typeOfRemoteAccessDialog,
      })
    );
  };
}

export function dispatchOpenRemoteAccessDialog() {
  store.dispatch(openRemoteAccessDialog());
}

export const onDepartmentSelect = withGlobalSpinnerActionEnhancer((department, email) => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    await activateEmailForDepartmentId(email, department.departmentId);
    dispatch(setStep(STEPS.ACTIVATION));
  } catch (e) {
    Logger.error('RemoteAccessDialog - activate email for department error', e);
  }

  dispatch(setIsLoading(false));
});

export function fetchDepartments(email) {
  return async (dispatch) => {
    try {
      dispatch(setStep(STEPS.INITIAL));
      const { permittedDepartments } = await sendEmailForEligibility(email);
      if (permittedDepartments.length > 1) {
        dispatch(setDepartments(permittedDepartments));
        dispatch(setStep(STEPS.CHOICE));
      } else if (permittedDepartments.length === 1) {
        dispatch(onDepartmentSelect(permittedDepartments[0], email));
      } else {
        Logger.error('RemoteAccessDialog - invalid permittedDepartments', permittedDepartments);
      }
    } catch (e) {
      dispatch(closeDialog({ id: typeOfRemoteAccessDialog }));
      Logger.error('RemoteAccessDialog - send email for eligibility error', e);
    }
  };
}

export function onActivationConfirm(ownProps) {
  return () => {
    const { selfClose } = ownProps;
    selfClose();
  };
}
